import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { of } from 'rxjs';

import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';

import { organizationFacilitiesTokenizer } from '../store';
import { FacilitiesGridTypes, LoadGridPayload } from '../types';
import { CONFIGURE_DEFAULT_PARAMS } from '../constants';

export const facilitiesResolver = (route: ActivatedRouteSnapshot) => {
  const _facilitiesSignalStore = organizationFacilitiesTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);

  const _params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );

  const gridType: FacilitiesGridTypes = route.data.type ?? 'main';

  const loadGrid = (id: string) => {
    const payload: LoadGridPayload = { params: _params };

    _facilitiesSignalStore.setByURL(gridType, id);
    _facilitiesSignalStore.loadFacilitiesGrid(payload);

    return of(true);
  };

  if (gridType === 'site') {
    // Use the site already resolved by the parent siteResolver to avoid a redundant HTTP call.
    const siteDetails = route.parent?.data['site'];
    const id = siteDetails?.id ?? '';
    if (!id) {
      console.error(
        'facilitiesResolver: Missing site id from parent route data',
      );
      return of(null);
    }
    return loadGrid(id);
  }

  return loadGrid(route.paramMap.get('id') ?? '');
};
